import React, { useState, useEffect } from "react";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";

const AddImport = ({ show, onClose }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
     const user_id = parseInt(localStorage.getItem("user_id"), 10);


  const [productCategories, setProductCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const [productOptions, setProductOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);
  const [aiPrompt, setAiPrompt] = useState("");

  const [showValidation, setShowValidation] = useState(false);

  useEffect(() => {
    axios
      .get(`${baseURL}/products/grouped-by-product-item-category`)
      .then((res) => {
        const data = res.data.data || [];
        const opts = [
          { value: "all", label: "All Categories" },
          ...data.map((cat) => ({
            value: cat.product_category_id.toString(),
            label: cat.product_category_name,
          })),
        ];
        setProductCategories(opts);
        if (opts.length) setSelectedCategory(opts[0]);
      })
      .catch(console.error);
  }, [baseURL]);

  useEffect(() => {
    if (!selectedCategory || selectedCategory.value === "all") {
      setProductOptions([]);
      setSelectedProduct(null);
      return;
    }

    axios
      .get(`${baseURL}/products/grouped-by-product-item-category`, {
        params: { productcategory_id: selectedCategory.value },
      })
      .then((res) => {
        const filteredCategory = res.data.data?.find(
          (cat) => cat.product_category_id.toString() === selectedCategory.value
        );
        const options = [];

        if (filteredCategory?.products?.length) {
          filteredCategory.products.forEach((product) => {
            options.push({
              value: product.product_id,
              label: product.product_name,
            });
          });
        }

        setProductOptions(options);
        setSelectedProduct(null);
      })
      .catch(console.error);
  }, [selectedCategory, baseURL]);

  const handleProductChange = (selected) => {
    setSelectedProduct(selected);
  };

  const handleReset = () => {
    setSelectedCategory(productCategories[0] || null);
    setSelectedProduct(null);
    setStartMonth(null);
    setEndMonth(null);
    setAiPrompt("");
    setShowValidation(false);
  };

  const handleGenerate = () => {
    if (
      !selectedCategory ||
      (selectedCategory.value !== "all" && !selectedProduct) ||
      !startMonth ||
      !endMonth
    ) {
      setShowValidation(true);
      return;
    }

    if (startMonth.toDate() > endMonth.toDate()) {
      alert("End Month cannot be before Start Month");
      return;
    }

    setShowValidation(false);

    const payload = {
      product_id: selectedProduct?.value,
      start_month: startMonth.format("YYYY-MM"),
      end_month: endMonth.format("YYYY-MM"),
      ai_prompt: aiPrompt || null,
      created_by: user_id,
    };

    axios
      // .post(`${baseURL}/menumaker/monthly-generate/items`, payload)
        .post(`${baseURL}/generate-menu`, payload)
      .then((res) => {
        // alert(res.data.message);
        onClose(); // close modal
        handleReset(); // clear fields
      })
      .catch((err) => {
        console.error(err);
        const msg =
          err.response?.data?.message ||
          "Something went wrong. Please try again.";
        // alert(msg);
      });
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton style={{ backgroundColor: "#3ab384" }}>
        <h3 className="modal-title text-white">Create AI Menu Maker</h3>
      </Modal.Header>

      <Modal.Body>
        <div className="row mb-3">
          {/* Category */}
          <div className="col-lg-6 mb-3">
            <label className="text-black font-w500 fs-7">
              Product Category<span className="required">*</span>
            </label>
            <Select
              value={selectedCategory}
              onChange={setSelectedCategory}
              options={productCategories}
              placeholder="Select Product Category"
            />
            {showValidation && !selectedCategory && (
              <span className="text-danger fs-7">This field is required</span>
            )}
          </div>

          {/* Product */}
          <div className="col-lg-6 mb-3">
            <label className="text-black font-w500 fs-7">
              Product<span className="required">*</span>
            </label>
            <Select
              placeholder="Select Product"
              options={productOptions}
              onChange={handleProductChange}
              value={
                productOptions.find(
                  (opt) => opt.value === selectedProduct?.value
                ) || null
              }
              isDisabled={!selectedCategory || selectedCategory.value === "all"}
            />
            {showValidation &&
              selectedCategory?.value !== "all" &&
              !selectedProduct && (
                <span className="text-danger fs-7">
                  This field is required
                </span>
              )}
          </div>

          {/* Start Month */}
          <div className="col-lg-6 mb-3">
            <label className="text-black font-w500 fs-7">
              Start Month<span className="required">*</span>
            </label>
            <div className="datepicker-wrapper d-flex align-items-center gap-2">
              <div className="input-group-text bg-transparent border-0 px-0">
                <i className="fa-solid fa-calendar-days fs-4"></i>
              </div>
              <DatePicker
                value={startMonth}
                onChange={setStartMonth}
                format="MMM-YYYY"
                onlyMonthPicker
                mode="single"
                calendarPosition="top"
              />
            </div>
            {showValidation && !startMonth && (
              <span className="text-danger fs-7">
                This field is required
              </span>
            )}
          </div>

          {/* End Month */}
          <div className="col-lg-6 mb-3">
            <label className="text-black font-w500 fs-7">
              End Month<span className="required">*</span>
            </label>
            <div className="datepicker-wrapper d-flex align-items-center gap-2">
              <div className="input-group-text bg-transparent border-0 px-0">
                <i className="fa-solid fa-calendar-days fs-4"></i>
              </div>
              <DatePicker
                value={endMonth}
                onChange={setEndMonth}
                format="MMM-YYYY"
                onlyMonthPicker
                mode="single"
                calendarPosition="top"
              />
            </div>
            {showValidation && !endMonth && (
              <span className="text-danger fs-7">
                This field is required
              </span>
            )}
          </div>

          {/* AI Prompt */}
          <div className="col-12 mb-3">
            <label className="text-black font-w500 fs-7">
             Description
            </label>
            <textarea
              className="form-control"
              rows={2}
              placeholder="Description..."
              value={aiPrompt}
              onChange={(e) => setAiPrompt(e.target.value)}
            ></textarea>
          </div>

          {/* Buttons */}
          <div className="col-12 mt-4 d-flex align-items-end justify-content-end gap-2">
            <Button variant="secondary" size="sm" onClick={handleReset}>
              Reset
            </Button>
            <Button variant="primary" size="sm" onClick={handleGenerate}>
              <i className="fas fa-robot me-2 text-white"></i>Generate
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddImport;
